import { EditableCondition } from '../../types';
import { useRequirementConditionsState } from '../requirement';

export const useRemoveAllConditions = () => {
  const { setConditions } = useRequirementConditionsState();
  const emptyConditions: EditableCondition[] = [];
  return () => setConditions(() => emptyConditions);
};
